import { extendObservable, runInAction } from 'mobx';

import { FAQsController } from '../../../networking/controllers/FAQsController';
import { Logger } from '../../../helpers/Logger';

class FAQStoreClass {
  constructor() {
    extendObservable(this, {
      questions: null,
      get numberOfQuestions() {
        const reduceFn = (currentValue, section) => (section.questions || []).length + currentValue;
        return (this.questions || []).reduce(reduceFn, 0);
      },
    });
    this.id = null;
  }

  async fetchQuestions(id) {
    try {
      if (this.id !== id) {
        this.id = id;
        runInAction(() => {
          this.questions = null;
        });
      }
      const questions = await FAQsController.all(id);
      runInAction(() => {
        this.questions = questions;
      });
    } catch (error) {
      Logger.warn(error);
    }
  }
}

export const FAQStore = new FAQStoreClass();



// WEBPACK FOOTER //
// ./src/pages/product-detail/stores/FAQStore.js